<template>
    <section class="sub-container">
        <h2 v-if="subscriptionActive" class="sub-title-h2">{{ $lang('subscriptionIncluded.title') }}</h2>
        <h2 v-else class="sub-title-h2">{{ $lang('subscriptionIncluded.title2') }}</h2>

        <swiper 
            class="sub-included-items" 
            ref="swiper" 
            :options="swiperOption"
        >
            <swiper-slide 
                v-for="(item, index) in includedItems" 
                :key="index" 
                class="sub-included-item"
                v-if="item.show"
            >
                <div class="sub-included-item__img">
                    <img :src="item.img" :alt="item.title">
                </div>
                <h3 class="sub-included-item__title">
                    {{ item.title }}
                </h3>
                <p class="sub-included-item__text">
                    {{ item.text }}
                </p>
                <a v-if="subscriptionActive" class="link sub-included-item__link" :href="item.route">
                    <span>{{ item.linkText }}</span>
                </a>
            </swiper-slide>
        </swiper>
    </section>
</template>

<script>
export default {
    name: 'SubscriptionIncluded',
    data() {
        const subscriptionTypeId = window.laravel.latestSubscription.subscription_type_id;

        const types = {
            MY_TREE: 1,
            MY_TREE_PLUS: 2,
            MY_TREE_PLUS_YEAR: 3,
            MY_TREE_PLUS_YEAR_PROMO: 4
        };
        return {
            subscriptionTypeId,
            swiperOption: {
                spaceBetween: 16,
                breakpoints: {
                    1180: {
                        slidesPerView: 4,
                    },
                    1045: {
                        slidesPerView: 3.5,
                    },
                    768: {
                        slidesPerView: 2.5,
                    },
                    600: {
                        slidesPerView: 2.2,
                    },
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    }
                },
                watchOverflow: true
            },
            includedItems: [
                {   
                    img: require('../../../img/subscriptions/sub-tree.png'),
                    title: this.$lang('subscriptionIncluded.item1.title'),
                    text: this.$lang('subscriptionIncluded.item1.text'),
                    linkText: this.$lang('subscriptionIncluded.item1.linkText'),
                    route: '/cabinet/tree',
                    show: true
                },
                {
                    img: require('../../../img/subscriptions/sub-extended-pages.png'),
                    title: this.$lang('subscriptionIncluded.item2.title'),
                    text: this.$lang('subscriptionIncluded.item2.text'),
                    linkText: this.$lang('subscriptionIncluded.item2.linkText'),
                    route: '/cabinet/pages',
                    show: [types.MY_TREE_PLUS, types.MY_TREE_PLUS_YEAR, types.MY_TREE_PLUS_YEAR_PROMO].includes(subscriptionTypeId)
                },
                {
                    img: require('../../../img/subscriptions/sub-extended-pages.png'),
                    title: this.$lang('subscriptionIncluded.item2.1.title'),
                    text: this.$lang('subscriptionIncluded.item2.1.text'),
                    linkText: this.$lang('subscriptionIncluded.item2.linkText'),
                    route: '/cabinet/pages',
                    show: subscriptionTypeId === types.MY_TREE
                },
                {
                    img: require('../../../img/subscriptions/sub-call.png'),
                    title: this.$lang('subscriptionIncluded.item3.title'),
                    text: this.$lang('subscriptionIncluded.item3.text'),
                    linkText: this.$lang('subscriptionIncluded.item3.linkText'),
                    route: '/contacts#support',
                    show: true
                },
                {
                    img: require('../../../img/subscriptions/sub-ai.png'),
                    title: this.$lang('subscriptionIncluded.item4.title'),
                    text: this.$lang('subscriptionIncluded.item4.text'),
                    linkText: this.$lang('subscriptionIncluded.item4.linkText'),
                    route: 'https://t.me/officialy_mk_bot',
                    show: true
                },
            ]
        };
    },
    props: {
        subscriptionActive: {
            type: Boolean,
            default: true
        },
    },
}
</script>